import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { ThemeProvider } from "@mui/material/styles";
import "./App.css";
import { Layout } from "./Layout";
import { SettingsProvider } from "./context";
import { routesConfiguration } from "./const/RoutesConfiguration";
import { NotFound } from "./pages/NotFound/NotFound";
import { theme } from "./Theme";
import { Home } from "./pages";

function App() {
  return (
    <Router>
      <ThemeProvider theme={theme}>
        <SettingsProvider>
          <Layout>
            <Routes>
              <Route path="/" element={<Home />} />

              {routesConfiguration.map((route, index) =>
                ["en", "tc", "sc"].map((lang) => (
                  <Route
                    key={`${lang}-${index}`}
                    path={`/${lang}${route.path}`}
                    element={route.element}
                  />
                ))
              )}
              {/* Default: Redirect unknown routes */}
              <Route path="/*" element={<NotFound />} />
            </Routes>
          </Layout>
        </SettingsProvider>
      </ThemeProvider>
    </Router>
  );
}

export default App;
